import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { CostDiscoverySection } from '../components/CostDiscoverySection';
import { RoutineTransformationSection } from '../components/RoutineTransformationSection';
import { SocialProofTicker } from '../components/SocialProofTicker';
import { FeaturesSection } from '../components/FeaturesSection';
import { TrackProgressSection } from '../components/TrackProgressSection';
import { AlternativeCostsSection } from '../components/AlternativeCostsSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { OfferSection } from '../components/OfferSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function LandingPage() {
  return <>
      <Navbar data-id="element-682" />
      <main data-id="element-683">
        <Hero data-id="element-684" />
        <div className="w-full h-px bg-gold/20" data-id="element-685" />
        <CostDiscoverySection data-id="element-686" />
        <div className="w-full h-px bg-gold/20" data-id="element-687" />
        <RoutineTransformationSection data-id="element-688" />
        <div className="w-full h-px bg-gold/20" data-id="element-689" />
        <SocialProofTicker data-id="element-690" />
        <div className="w-full h-px bg-gold/20" data-id="element-691" />
        <FeaturesSection data-id="element-692" />
        <div className="w-full h-px bg-gold/20" data-id="element-693" />
        <AlternativeCostsSection data-id="element-694" />
        <div className="w-full h-px bg-gold/20" data-id="element-695" />
        <HowItWorksSection data-id="element-696" />
        <div className="w-full h-px bg-gold/20" data-id="element-697" />
        <TrackProgressSection data-id="element-698" />
        <div className="w-full h-px bg-gold/20" data-id="element-699" />
        <TestimonialsSection data-id="element-700" />
        <div className="w-full h-px bg-gold/20" data-id="element-701" />
        <OfferSection data-id="element-702" />
        <div className="w-full h-px bg-gold/20" data-id="element-703" />
        <GuaranteeSection data-id="element-704" />
        <div className="w-full h-px bg-gold/20" data-id="element-705" />
        <FAQSection data-id="element-706" />
        <div className="w-full h-px bg-gold/20" data-id="element-707" />
        <FinalCTA data-id="element-708" />
      </main>
      <Footer data-id="element-709" />
      <WhatsAppButton data-id="element-710" />
    </>;
}